import React, { useContext, useEffect, useState } from 'react'
import Radio, { Option } from '@Components/Fields/Radio'
import Button from '@Components/Buttons/Button'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { WorksReportRequestDTO } from '@Entities/report/works-report-request'
import { submitReportRequest, submitSongwriterReportRequest } from '@App/api/routes/search'
import { ExportType } from '@App/enum/export-type'

interface ExportCatalogFormProps {
    setIsFormSubmitted: (isFormSubmitted: boolean) => void
    songwriterCatalog?: boolean
}

const ExportCatalogForm = ({ songwriterCatalog = false, setIsFormSubmitted }: ExportCatalogFormProps) => {
    const {
        exportStore,
        catalogSearchStore,
        preloaderStore,
        rightsholderStore,
        songwriterStore,
        songwriterCatalogSearchStore,
    } = useContext(StoresContext)

    useEffect(() => {
        // fyi this store call opens the preloader, if more api calls are added then the preloader will need be dealt with
        exportStore.setExportType(songwriterCatalog ? ExportType.SONGWRITER_WORKS : ExportType.WORKS)
        exportStore.loadExportFormats().then()
    }, [])

    const workReportFormats: Option[] = exportStore.exportFormats
    const selectionQuery = songwriterCatalog
        ? songwriterCatalogSearchStore.catalogSelectionSearchQuery
        : catalogSearchStore.catalogSelectionSearchQuery
    const [worksReportRequest, setWorksReportRequest] = useState(new WorksReportRequestDTO(selectionQuery || {}))
    const onFormatChange = (value: Option) => {
        setWorksReportRequest({
            ...worksReportRequest,
            format: value.value,
        })
    }

    const isFormValid = (): boolean => !!worksReportRequest?.format

    const onSubmitCatalogExportRequest = () => {
        if (isFormValid()) {
            preloaderStore.openTransparentPreloader(true)
            const apiCall = songwriterCatalog
                ? submitSongwriterReportRequest(
                      songwriterStore.currentSongwriterId,
                      worksReportRequest,
                      ExportType.WORKS
                  )
                : submitReportRequest(rightsholderStore.currentRightsholderId, worksReportRequest, ExportType.WORKS)
            apiCall
                .then(() => {
                    setIsFormSubmitted(true)
                })
                .finally(() => preloaderStore.openTransparentPreloader(false))
        }
    }

    return (
        <>
            <Radio
                options={workReportFormats}
                field={{ name: 'File Type' }}
                direction="column"
                onChange={onFormatChange}
                title="File Type:"
            />
            <div className="download-button">
                <Button
                    mainColor
                    type="primary"
                    disabled={!isFormValid()}
                    onClick={() => onSubmitCatalogExportRequest()}
                >
                    Download
                </Button>
            </div>
        </>
    )
}

export default observer(ExportCatalogForm)
